<template>
  <div>
    <h2 style="text-align: center;" v-if="userInfo.remark !== '北京学校账号'">请使用学校编号登录进行报名</h2>
    <a-spin v-else :spinning="spinning" tip="加载中...">
    <div class="content-warp" v-if="!spinning">
      <EditAgency v-if="agencyList.length === 0" @ok="queryAgency"/>
      <div class="list" v-else>
        <div class="col" v-for="(item,index) in agencyList" :key="index">
          <div class="warp">
            <img :src="item.unitLogo||nullImg" class="or-img">
            <div class="content">
              <p><span class="or-title">{{$t('名称')}}：</span>{{item.unitName||'名称'}}
                &ensp;&ensp;<span class="or-title">{{$t('地区')}}：</span>{{item.address||''}}
                &ensp;&ensp;<span class="or-title">{{$t('类型')}}：</span>{{matchFun.agencyTypeText(item.unitType)}}
              </p>
            </div>
          </div>
        </div>
        <div class="card-container">
          <a-tabs v-model="cardType" type="card" @change="changeCardType">
            <a-tab-pane :key="1" tab="运动员报名">
              
                <div style="overflow: hidden;background: #fff;">
                  <SelectJoinPlayer :item="item" :agencyId="agencyList[0].agencyId" :teamId="agencyList[0].teamId" @ok="joinOk"/>
                  <div style="overflow: hidden;margin-top: 20px;">
                    <span style="font-size: 16px;font-weight: bold;color: black;">运动员库</span>
                    <a-radio-group v-model="type" style="margin-bottom: 16px;float: right;margin-left: 10px;">
                      <a-radio-button :value="1">
                        审核通过
                      </a-radio-button>
                      <a-radio-button :value="0">
                        待审核
                      </a-radio-button>
                      <a-radio-button :value="2">
                        审核未通过
                      </a-radio-button>
                    </a-radio-group>
                    <a-button type="primary" style="float: right;" icon="plus" @click="$refs.editPlayer.show(null)">
                      新注册运动员
                    </a-button>
                  </div>
                </div>
   
              <div>
                <template v-if="playerList[type]">
                  男子：{{ calSexList(1, playerList[type]).length }}人
                  <div style="overflow: hidden;border-top: 1px solid #e8e8e8;padding-top: 20px;margin-top: 20px;"> 
                    <div @click="join(item)" v-for="(item,index) in calSexList(1, playerList[type])" class="player-css" :style="{width: item.status === 1 ? '80px' : '100%'}">
                      <img v-if="item.image" :src="item.image" style="width:55px;height:70px;border-radius:5px;margin-left:10px;float:left;"/>
                      <div style="margin-left:10px;width:90px;float:left;overflow: hidden;height: 35px;">{{ item.name }}</div>
                      <!-- <template v-if="item.combatList.length > 0">
                        参赛项目：<a-tag color="blue" v-for="(it,ind) in item.combatList" :key="ind">{{ it.combat === null ? it.title : it.combat }}</a-tag>
                      </template> -->
                      <!-- <template v-if="item.major">专业：{{ item.major }}&ensp;&ensp;学号：{{ item.studentId }}&ensp;&ensp;联系电话：{{ item.mobile }}&ensp;&ensp;
                        入学时间：{{ item.enrollmentDate }}&ensp;&ensp;预计毕业时间：{{ item.graduationDate }}
                      </template> -->
                      <template v-if="item.status === 2 && item.msg"><span style="color: red;">驳回信息：{{ item.msg }}</span></template>
                      <template v-if="item.status === 2 && item.titles === null && item.msg === null"><span style="color: red;">驳回信息：请完善注册信息</span></template>
                      <div v-if="type !== 1" style="float:right;width:136px;">
                        <a-button icon="edit" size="small" type="primary" @click.stop="$refs.editPlayer.show(item)">编辑</a-button>
                        <a-popconfirm
                          title="确定要删除吗?"
                          @confirm.stop="() => delPlayer(item)"
                        >
                          <a-button icon="delete" size="small" type="danger">删除</a-button>
                        </a-popconfirm>
                      </div>
                      <!-- <a-button style="float:right;" v-else size="small" type="primary" @click="join(item)">点击报名参赛</a-button> -->
                    </div>
                  </div>
                  女子：{{ calSexList(2, playerList[type]).length }}人
                 
                  <div style="overflow: hidden;border-top: 1px solid #e8e8e8;padding-top: 20px;margin-top: 20px;"> 
                    <div @click="join(item)" v-for="(item,index) in calSexList(2, playerList[type])" class="player-css" :style="{width: item.status === 1 ? '80px' : '100%'}">
                      <img v-if="item.image" :src="item.image" style="width:55px;height:70px;border-radius:5px;margin-left:10px;float:left;"/>
                      <div style="margin-left:10px;width:90px;float:left;overflow: hidden;height: 35px;">{{ item.name }}</div>
                      <!-- <template v-if="item.combatList.length > 0">
                        参赛项目：<a-tag color="blue" v-for="(it,ind) in item.combatList" :key="ind">{{ it.combat === null ? it.title : it.combat }}</a-tag>
                      </template> -->
                      <!-- <template v-if="item.major">专业：{{ item.major }}&ensp;&ensp;学号：{{ item.studentId }}&ensp;&ensp;联系电话：{{ item.mobile }}&ensp;&ensp;
                        入学时间：{{ item.enrollmentDate }}&ensp;&ensp;预计毕业时间：{{ item.graduationDate }}
                      </template> -->
                      <template v-if="item.status === 2 && item.msg"><span style="color: red;">驳回信息：{{ item.msg }}</span></template>
                      <template v-if="item.status === 2 && item.titles === null && item.msg === null"><span style="color: red;">驳回信息：请完善注册信息</span></template>
                      <div v-if="type !== 1" style="float:right;width:136px;">
                        <a-button icon="edit" size="small" type="primary" @click.stop="$refs.editPlayer.show(item)">编辑</a-button>
                        <a-popconfirm
                          title="确定要删除吗?"
                          @confirm="() => delPlayer(item)"
                        >
                          <a-button icon="delete" size="small" type="danger">删除</a-button>
                        </a-popconfirm>
                      </div>
                      <!-- <a-button style="float:right;" v-else size="small" type="primary" @click="join(item)">点击报名参赛</a-button> -->
                    </div>
                  </div>
                </template>
                <a-empty v-else>
                  <span slot="description" style="color:#c1bebe;"> 暂无数据</span>
                </a-empty>
                </div>
                
            </a-tab-pane>
            <a-tab-pane :key="2" tab="带队成员">
              <a-radio-group v-model="staffType" style="margin-bottom: 16px">
                <a-radio-button :value="1">
                  审核通过
                </a-radio-button>
                <a-radio-button :value="0">
                  待审核
                </a-radio-button>
                <a-radio-button :value="2">
                  审核未通过
                </a-radio-button>
              </a-radio-group>
              <a-button type="primary" icon="plus" @click="$refs.editStaff.show(null, agencyList[0].agencyId)">
                添加带队成员提交审核
              </a-button>
              <template v-if="staffList[staffType]">
                <div v-for="(item,index) in staffList[staffType]" style="margin-bottom:10px;border-bottom: 1px solid #e8e8e8;line-height: 35px;padding-bottom: 10px;overflow: hidden;">
                  <div style="float:left;"><a-input-number style="width: 60px;" v-model="item.sort" :min="1" />&ensp;<a-button @click="updateSort(item)">修改序号</a-button> </div>
                  <img v-if="item.image" :src="item.image" style="width:35px;height:35px;border-radius:5px;margin-left:10px;float:left;"/>
                  <div style="margin:0 10px;float:left;overflow: hidden;height: 35px;">{{ item.name }}</div>
                  <a-tag color="blue">{{ matchFun.getLeaderName2(item.type) }}</a-tag>
                  职称：{{ item.protitle }}&ensp;&ensp;学历：{{ item.educational }}&ensp;&ensp;培训证书有效期：{{ item.validityDate }}&ensp;&ensp;联系电话：{{ item.mobile }}
                  <template v-if="item.status === 2 && item.msg"><br/><span style="color: red;">驳回信息：{{ item.msg }}</span></template>
                  <div v-if="staffType !== 1" style="float:right;width:136px;">
                    <a-button icon="edit" size="small" type="primary" @click="$refs.editStaff.show(item, agencyList[0].agencyId)">编辑</a-button>
                    <a-popconfirm
                      title="确定要删除吗?"
                      @confirm="() => delStaff(item)"
                    >
                      <a-button icon="delete" size="small" type="danger">删除</a-button>
                    </a-popconfirm>
                  </div>
                  <template  v-else>
                    <a-button v-if="staffIdList.indexOf(item.id) > -1" style="float:right;" size="small" type="danger" @click="addStaffIds(item)">取消本次带队</a-button>
                    <a-button v-else style="float:right;" size="small" type="primary" @click="addStaffIds(item)">点击本次比赛带队</a-button>
                  </template>
                  
                  <a-tag color="#f50" v-if="staffIdList.indexOf(item.id) > -1">本次带队</a-tag>
                </div>
              </template>
              <a-empty v-else>
                <span slot="description" style="color:#c1bebe;"> 暂无数据</span>
              </a-empty>
            </a-tab-pane>
            <!-- <a-tab-pane :key="3" tab="运动员报名">
              <template v-if="item">
                <JoinPlayer :item="item" :agencyId="agencyList[0].agencyId" :teamId="agencyList[0].teamId" @ok="joinOk"/>
              </template>
              <template v-else>
                <h3 style="text-align: center;">请选择在库运动员审核通过的运动员进行报名<span @click="joinOk" style="color:red;cursor: pointer;">去选择</span></h3>
              </template>
            </a-tab-pane> -->
            <a-tab-pane :key="4" tab="报名列表">
              <PaySign :agencyId="agencyList[0].agencyId" :teamId="agencyList[0].teamId" :cardType="cardType" @ok="updateJoin"/>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
    <EditPlayer ref="editPlayer" @ok="examineList"/>
    <EditStaff ref="editStaff" @ok="findStaff"/>
  </a-spin>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import EditAgency from './EditAgency'
import EditPlayer from './EditPlayer'
import EditStaff from './EditStaff'
import JoinPlayer from './JoinPlayer'
import SelectJoinPlayer from './SelectJoinPlayer'
import PaySign from './PaySign'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'JoinFactory',
  components: {
    EditAgency,
    EditPlayer,
    EditStaff,
    JoinPlayer,
    SelectJoinPlayer,
    PaySign
  },
  mounted () {
    this.queryAgency()
    this.examineList()
    this.leaders = JSON.parse(this.matchInfo.staffData)
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      spinning: false,
      matchInfo: store.getters['match/matchInfo'],
      leaders: {},
      agencyList: [],
      playerList: [],
      staffList: [],
      cardType: 1,
      type: 1,
      staffType: 1,
      item: null,
      staffIdList: [],
      matchFun
    }
  },
  methods: {
    calSexList(sex, list){
      return list.filter((item)=>{
        return item.sex === sex
      })
    },
    queryAgency () {
      this.spinning = true
      this.$api.join.agencyList().then(res => {
        this.spinning = false
        if (res.status === 0) {
          this.agencyList = res.data
          if (this.agencyList.length > 0) {
            this.findStaff()
            this.queryLeadersByTeam()
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    examineList () {
      this.$api.match.examineListByAccount().then(res => {
        if (res.status === 0) {
          this.playerList = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取运动员列表失败')
      })
    },
    findStaff () {
      this.staffType = 1
      this.$api.match.staffMsgList({agencyId: this.agencyList[0].agencyId}).then(res => {
        if (res.status === 0) {
          this.staffList = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取教练列表失败')
      })
    },
    // 通过队伍查询该队伍的带队教练信息
    queryLeadersByTeam () {
      this.$api.join.queryLeadersByTeam(this.matchId, this.agencyList[0].teamId).then(res => {
        if (res.status === 0 && res.data) {
          this.staffIdList = res.data.split(',').map(item => Number(item))
        } else {
          this.staffIdList = []
        }
      })
    },
    addStaffIds (itemData) {
      let stafIndex = this.staffIdList.indexOf(itemData.id);
      if ( stafIndex > -1 ) {
        if (this.staffIdList.length === 1) {
          this.$message.error('请至少保留一位带队人员')
          return
        }
        this.staffIdList.splice(stafIndex, 1)
        this.leaderStaff(this.staffIdList.join(','))
      } else {
        let pass = true
        let content = ''
        for (let j = 0; j < this.leaders.length; j++) {
          let item = this.leaders[j]
          console.log(item.code, itemData.type)
          if (item.num > 0 && item.code === itemData.type) {
            let arr = []
            this.staffList[1].forEach(element => {
              if (element.type === item.code && this.staffIdList.indexOf(element.id) > -1) {
                arr.push(element)
              }
            });
            console.log(item, arr)
            let len =  arr.length + 1;
            if (len > item.num ) {
              content = item.name + '最多选择' + item.num + '个'
              pass = false
              break
            }
          }
        }
        if (!pass) {
          this.$message.error(content)
          return
        }
        this.staffIdList.push(itemData.id)
        this.leaderStaff(this.staffIdList.join(','), itemData.id)
      }
      
    },
    leaderStaff (staffIds, id) {
      this.$api.join.LeaderStaffAddOrUpdateStu({staffIds: staffIds, matchId: this.matchId, teamId: this.agencyList[0].teamId}).then(res => {
        if (res.status === 0) {
          
        } else {
          let stafIndex = this.staffIdList.indexOf(id);
          this.staffIdList.splice(stafIndex, 1)
          this.$message.error(res.msg)
        }
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    callback(key) {
      console.log(key);
    },
    addOk (type) {
      this.type = type
      this.item = null
      this.examineList()
    },
    joinOk () {
      this.type = 1
      this.cardType = 1
      this.item = null
      this.examineList()
    },
    join (item) {
      if (item.status === 1) {
        console.log(item)
        if (new Date(item.graduationDate) < new Date()) {
          this.$message.error('该学员于'+ item.graduationDate +'已毕业，禁止参加')
          return
        }
        this.item = item
      } else {
        this.$message.error('只有通过审核的选手才可进行报名')
      }
      // this.cardType = 3
    },
    updateJoin (item) {
      // this.item = item
      console.log(item)
      this.findSinglePlayer(item.cardId, item.combat)
    },
    findSinglePlayer (cardId, combat) {
      
      this.$api.join.findSinglePlayer({agencyId: this.agencyList[0].agencyId, cardId: cardId}).then(res => {
        if (res.status === 0) {
          console.log(res.data,888)
          this.cardType = 1
          this.item = res.data
          this.item.combatList = []
          combat.forEach(element => {
              this.item.combatList.push({
                title: element.title
              })
          });
          
        }
      }).catch(err => {
        console.log(err)
      })
    },
    changeCardType (e) {
      console.log(e)
      this.item = null
    },
    delPlayer (item) {
      this.$api.match.examineDelete({id: item.id}).then(res => {
        if (res.status === 0) {
          this.examineList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    delStaff (item) {
      this.$api.match.staffMsgDelete({id: item.id}).then(res => {
        if (res.status === 0) {
          this.findStaff()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    updateSort (item) {
      this.$api.match.updateStaffSort({id: item.id, sort: item.sort}).then(res => {
        if (res.status === 0) {
          this.findStaff()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content-warp{
  padding-bottom: 50px;
}
.list{
  .col{
    margin-bottom: 20px;
  }
  .warp{
    height: 50px;
    border-radius: 2px;
    display: flex;
    flex-direction: row;
    position: relative;
    background-color:#fff;
    &:hover{
      cursor: pointer;
      background-color: #f7f7f7;
    }
    .or-img{
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
      padding: 10px;
    }
    .content{
      height: 100%;
      display: flex;
      flex-direction: column;
      p{
        flex: 1;
        color: #000;
        line-height: 50px;
        margin-bottom: 0;
        .or-title{
          color: #999;
        }
      }
    }
  }
}
.player-css{
  cursor: pointer;margin-bottom:10px;line-height: 35px;padding-bottom: 10px;overflow: hidden;width: 80px;float: left;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/JoinFactory.vue